import { gql } from "@apollo/client";

export const GET_FRECUENCIA_BY_VISITA = gql`
  query frecuenciaByVisita($idVisita: Int!) {
    frecuenciaByVisita(idVisita: $idVisita){
      descripccion
      frecuencia
    } 
    }
`;